import { render, staticRenderFns } from "./SalesAnalysisListView.vue?vue&type=template&id=5062595a&scoped=true"
import script from "./SalesAnalysisListView.vue?vue&type=script&lang=js"
export * from "./SalesAnalysisListView.vue?vue&type=script&lang=js"
import style0 from "./SalesAnalysisListView.vue?vue&type=style&index=0&id=5062595a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5062595a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5062595a')) {
      api.createRecord('5062595a', component.options)
    } else {
      api.reload('5062595a', component.options)
    }
    module.hot.accept("./SalesAnalysisListView.vue?vue&type=template&id=5062595a&scoped=true", function () {
      api.rerender('5062595a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/salesanalysis/SalesAnalysisListView.vue"
export default component.exports